import React from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";

import "./dashboard.scss";

const stats = [
  { label: "Today’s Orders", value: "128", trend: "+18 vs yesterday", icon: "▦" },
  { label: "Today’s Revenue", value: "RM 2,846", trend: "+12.8% today", icon: "RM" },
  { label: "Active Vendors", value: "42", trend: "8 vendors selling today", icon: "◫" },
  { label: "Pending Collection", value: "31", trend: "Collection before 8:00 PM", icon: "⌁" },
  { label: "Cancelled Orders", value: "6", trend: "Manual review required", icon: "×" },
  { label: "Low / Sold Out Items", value: "14", trend: "Needs vendor attention", icon: "!" },
];

const recentOrders = [
  { order: "SB-10084", vendor: "Hikari House", customer: "Channie", status: "Collectible", amount: "RM18.90" },
  { order: "SB-10083", vendor: "Green Bowl", customer: "Daniel", status: "Paid", amount: "RM12.50" },
  { order: "SB-10082", vendor: "Daily Bakery", customer: "Mei Ling", status: "Collected", amount: "RM9.90" },
  { order: "SB-10081", vendor: "Urban Cafe", customer: "Aiman", status: "Cancelled", amount: "RM15.00" },
];

const vendorSummary = [
  { name: "Hikari House", orders: 28, revenue: "RM529.20", stock: "Low" },
  { name: "Green Bowl", orders: 21, revenue: "RM358.50", stock: "Available" },
  { name: "Daily Bakery", orders: 18, revenue: "RM178.20", stock: "Sold Out" },
];

const DashboardPage = () => {
  return (
    <div className="dashboard-page">
      <section className="dashboard-page__hero">
        <div>
          <p className="dashboard-page__welcome">Welcome back, Admin</p>
          <h2 className="dashboard-page__heading">Monitor platform performance, vendor activity, and daily order status.</h2>
        </div>
        <div className="dashboard-page__hero-actions">
          <NavLink to="/admin/reports" className="dashboard-hero__secondary-btn">
            View Reports
          </NavLink>
          <NavLink to="/admin/vendors/create" className="dashboard-hero__primary-btn">
            + Add Vendor
          </NavLink>
        </div>
      </section>

      <section className="dashboard-page__stats">
        {stats.map((item) => (
          <article className="dashboard-page__stat-card" key={item.label}>
            <div className="dashboard-page__stat-icon">{item.icon}</div>
            <p className="dashboard-page__stat-label">{item.label}</p>
            <h3 className="dashboard-page__stat-value">{item.value}</h3>
            <span className="dashboard-page__stat-trend">{item.trend}</span>
          </article>
        ))}
      </section>

      <section className="dashboard-page__grid">
        <article className="dashboard-page__panel dashboard-page__panel--wide">
          <div className="dashboard-page__panel-header">
            <div>
              <h3>Recent Orders</h3>
              <p>Latest guest checkout orders from the buyer mobile app.</p>
            </div>
            <button type="button">View All</button>
          </div>

          <div className="dashboard-page__table">
            <div className="dashboard-page__table-head">
              <span>Order</span><span>Vendor</span><span>Customer</span><span>Status</span><span>Amount</span>
            </div>
            {recentOrders.map((order) => (
              <div className="dashboard-page__table-row" key={order.order}>
                <strong>{order.order}</strong>
                <span>{order.vendor}</span>
                <span>{order.customer}</span>
                <span className={`dashboard-page__badge dashboard-page__badge--${order.status.toLowerCase()}`}>{order.status}</span>
                <strong>{order.amount}</strong>
              </div>
            ))}
          </div>
        </article>

        <article className="dashboard-page__panel">
          <div className="dashboard-page__panel-header dashboard-page__panel-header--stacked">
            <h3>Order Status</h3>
            <p>Today’s distribution</p>
          </div>
          <div className="dashboard-page__donut">68%</div>
          <div className="dashboard-page__summary-row"><span>Paid</span><strong>58</strong></div>
          <div className="dashboard-page__summary-row"><span>Collectible</span><strong>31</strong></div>
          <div className="dashboard-page__summary-row"><span>Collected</span><strong>33</strong></div>
          <div className="dashboard-page__summary-row"><span>Cancelled</span><strong>6</strong></div>
        </article>
      </section>

      <section className="dashboard-page__grid dashboard-page__grid--bottom">
        <article className="dashboard-page__panel dashboard-page__panel--wide">
          <div className="dashboard-page__panel-header">
            <div>
              <h3>Sales Trend</h3>
              <p>Last 7 days revenue overview.</p>
            </div>
          </div>
          <div className="dashboard-page__chart-bars">
            {[38, 62, 44, 76, 52, 88, 70].map((height, index) => <span key={index} style={{ height: `${height}%` }} />)}
          </div>
        </article>

        <article className="dashboard-page__panel">
          <div className="dashboard-page__panel-header dashboard-page__panel-header--stacked">
            <h3>Top Vendors</h3>
            <p>By revenue today</p>
          </div>
          {vendorSummary.map((vendor) => (
            <div className="dashboard-page__vendor" key={vendor.name}>
              <div><strong>{vendor.name}</strong><span>{vendor.orders} orders</span></div>
              <div><strong>{vendor.revenue}</strong><span>{vendor.stock}</span></div>
            </div>
          ))}
        </article>
      </section>
    </div>
  );
};

export default DashboardPage;
